/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var BusinessViewBrokerType;

(function (BusinessViewBrokerType) {
  BusinessViewBrokerType["B2B_BROKERS"] = "b2b_brokers";
  BusinessViewBrokerType["B2B_DIRECT_SALES"] = "b2b_direct_sales";
  BusinessViewBrokerType["B2B_PARTNERS"] = "b2b_partners";
  BusinessViewBrokerType["B2B_RECRUITMENT_PARTNERS"] = "b2b_recruitment_partners";
  BusinessViewBrokerType["B2C_DRIVERS"] = "b2c_drivers";
  BusinessViewBrokerType["B2C_CONTRACTORS"] = "b2c_contractors";
  BusinessViewBrokerType["OTHERS"] = "others";
})(BusinessViewBrokerType || (BusinessViewBrokerType = {}));